/**
 * @generated SignedSource<<2b51403a2b212cb47dc53b8492bc3ec2>>
 * @relayHash ccf377627f575b4d14e9df7c37f6701d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bacdce51376d81c5f867bd8d669c95640de30fc2d03d26b93b4fbf0d39f2c171

import type { ConcreteRequest } from 'relay-runtime';
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
export type StatusAndApprovalsConfigSetContentStateSettingsMutation$variables = {
  contentStatesSetting: boolean;
  customStatesSetting: boolean;
  spaceKey: string;
  spaceStatesSetting: boolean;
};
export type StatusAndApprovalsConfigSetContentStateSettingsMutation$data = {
  readonly setContentStateSettings: {
    readonly contentStatesAllowed: boolean | null | undefined;
    readonly customContentStatesAllowed: boolean | null | undefined;
    readonly spaceContentStates: ReadonlyArray<{
      readonly color: string;
      readonly id: string | null | undefined;
      readonly name: string;
      readonly restrictionLevel: ContentStateRestrictionLevel;
    } | null | undefined> | null | undefined;
    readonly spaceContentStatesAllowed: boolean | null | undefined;
  } | null | undefined;
};
export type StatusAndApprovalsConfigSetContentStateSettingsMutation = {
  response: StatusAndApprovalsConfigSetContentStateSettingsMutation$data;
  variables: StatusAndApprovalsConfigSetContentStateSettingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentStatesSetting"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customStatesSetting"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceStatesSetting"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentStatesSetting",
        "variableName": "contentStatesSetting"
      },
      {
        "kind": "Variable",
        "name": "customStatesSetting",
        "variableName": "customStatesSetting"
      },
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      },
      {
        "kind": "Variable",
        "name": "spaceStatesSetting",
        "variableName": "spaceStatesSetting"
      }
    ],
    "concreteType": "ContentStateSettings",
    "kind": "LinkedField",
    "name": "setContentStateSettings",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "contentStatesAllowed"
      },
      {
        "kind": "ScalarField",
        "name": "spaceContentStatesAllowed"
      },
      {
        "kind": "ScalarField",
        "name": "customContentStatesAllowed"
      },
      {
        "concreteType": "ContentState",
        "kind": "LinkedField",
        "name": "spaceContentStates",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "color"
          },
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "restrictionLevel"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "StatusAndApprovalsConfigSetContentStateSettingsMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "StatusAndApprovalsConfigSetContentStateSettingsMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "ccf377627f575b4d14e9df7c37f6701d",
    "id": "bacdce51376d81c5f867bd8d669c95640de30fc2d03d26b93b4fbf0d39f2c171",
    "metadata": {},
    "name": "StatusAndApprovalsConfigSetContentStateSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation StatusAndApprovalsConfigSetContentStateSettingsMutation($spaceKey:String!,$contentStatesSetting:Boolean!,$customStatesSetting:Boolean!,$spaceStatesSetting:Boolean!){setContentStateSettings(spaceKey:$spaceKey,contentStatesSetting:$contentStatesSetting,customStatesSetting:$customStatesSetting,spaceStatesSetting:$spaceStatesSetting){contentStatesAllowed,spaceContentStatesAllowed,customContentStatesAllowed,spaceContentStates{name,color,id,restrictionLevel}}}"
  }
};
})();

(node as any).hash = "a404c4bfc7b55d577281ff4d9609ab63";

export default node;
